export const REMEMBER_BOARD = 'events/REMEMBER_BOARD';

/**
 * @param board
 * @return {{type: string, payload: board}
 */
export const rememberBoard = (board) => ({
  type: REMEMBER_BOARD,
  payload: board,
});
